import React, { FC } from 'react'
import { Project } from 'models/project'
import { Source, Layer } from 'react-map-gl'
import styles from './ProjectArea.module.scss'

type ProjectAreaProps = {
  project?: Project
  centro?: boolean
}

export const ProjectArea: FC<ProjectAreaProps> = ({ project, centro }) => {
  if (!project) {
    return null
  }
  if (centro === true) {
    return (
      <Source key="project-area" type="geojson" data={project.centroid}>
        <Layer
          key="project-area-point-C"
          id="project-area-point-C"
          type="circle"
          paint={{
            'circle-color': "#FFE800",
            'circle-radius': 6
          }}
        />
        <Layer
          key="project-area-point"
          id="project-area-point"
          type="circle"
          paint={{
            'circle-color': styles.primary,
            'circle-radius': 4
          }}
        />
      </Source>
    )
  } else {
    return (
      <Source key="project-area" type="geojson" data={project.geometry}>
        <Layer
          key="project-area-fill"
          id="project-area-fill"
          type="fill"
          paint={{
            'fill-color': styles.primary,
            'fill-opacity': 0.1,
          }}
        />
        <Layer
          key="project-area-line"
          id="project-area-line"
          type="line"
          paint={{
            'line-width': 2,
            'line-color': styles.primary,
            'line-dasharray': [4, 2],
          }}
        />
      </Source>
    )
  }

}

ProjectArea.displayName = 'ProjectArea'
